import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { PatientSearch } from './PatientSearch';
import { PatientView } from './PatientView';

interface PatientsProps {
    match: { url: string };
}
export function Patients({ match }: PatientsProps) {
    return (
        <Switch>
            <Route path={`${match.url}/:id`} component={PatientView} exact />
            <Route path={`${match.url}/`} component={PatientSearch} exact />
        </Switch>
    );
}
